export const SHIFT_CLICK = 'SHIFT_CLICK';
export const REORDER_TRACK = 'REORDER_TRACK';
export const TEMPLATE_RENDERED = 'TEMPLATE_RENDERED';
export const ADD_VERTICAL_ITEMS_TO_WIDGET = 'Web.PageInterface.v1_0.AddVerticalItemsToLastWidgetMethod';
export const ADD_HORIZONTAL_ITEMS_TO_WIDGET = 'Web.PageInterface.v1_0.AddHorizontalItemsToLastWidgetMethod';
export const ADD_VISUAL_ROW_ITEMS_TO_WIDGET = 'Web.PageInterface.v1_0.AddVisualRowItemsToLastWidgetMethod';
export const ADD_DESCRIPTIVE_ROW_ITEMS_TO_WIDGET = 'Web.PageInterface.v1_0.AddDescriptiveRowItemsToLastWidgetMethod';
export const ADD_WIDGETS_TO_TEMPLATE = 'Web.PageInterface.v1_0.AddWidgetsToTemplateMethod';
export const REMOVE_ROW_ITEM_FROM_WIDGET = 'Web.PageInterface.v1_0.RemoveRowItemFromWidgetMethod';
export const CREATE_TEMPLATE = 'TemplateListInterface.v1_0.CreateTemplateMethod';
export const BIND_TEMPLATE = 'TemplateListInterface.v1_0.BindTemplateMethod';
export const CREATE_AND_BIND_TEMPLATE = 'TemplateListInterface.v1_0.CreateAndBindTemplateMethod';
export const URL_CHANGE = 'URL_CHANGE';
export const REMOVE_TEMPLATE = 'TemplateListInterface.v1_0.RemoveTemplateMethod';
export const INVALIDATE_TEMPLATE = 'TemplateListInterface.v1_0.InvalidateTemplatesMethod';
export const SOFT_REFRESH_TEMPLATES = 'Web.TemplateListInterface.v1_0.SoftRefreshTemplatesMethod';
